import React from 'react';
import { ListItem as MuiListItem } from '@mui/material';
import clsx from 'clsx';
import { ListItemProps, listItemClasses } from './types';

export type { ListItemProps } from './types';

export function ListItem(props: ListItemProps) {
  const { className, ...rest } = props;
  return (
    <MuiListItem
      {...rest}
      className={clsx(
        className,
        {
          [listItemClasses.withSecondaryAction]: rest.secondaryAction !== undefined,
        },
      )}
    />
  );
}
